import { modelHelperModule } from './model-helper';

export const reviewQualityModelModule = angular
  .module('Q.models.review-quality', [modelHelperModule])

  .factory('ReviewQuality', function (ModelHelper) {
    return ModelHelper.defineResource({
      name: 'ReviewQuality',
      endpoint: 'review_qualities',
      methods: {},
      staticMethods: {},
      relations: {
        hasOne: {
          Team: {
            localField: 'team',
            localKey: 'teamId',
          },
        },
      },
    });
  });
